export default __webpack_public_path__ + "static/media/GIFMedico.445c4b28.gif";